import { Icon } from "@rmwc/icon"
import "@rmwc/icon/styles"

const IconComponent = <Icon icon="error_outline" />

export const ErrorOutline = IconComponent
